import { render, staticRenderFns } from "./xwsxjd.vue?vue&type=template&id=3c1088c7&scoped=true"
import script from "./xwsxjd.vue?vue&type=script&lang=js"
export * from "./xwsxjd.vue?vue&type=script&lang=js"
import style0 from "./xwsxjd.vue?vue&type=style&index=0&id=3c1088c7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1088c7",
  null
  
)

export default component.exports